import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/auth")({
  component: AuthLayout,
});

// Minimal, unguarded layout for the auth subtree.
// No Navbar, no Sidebar, no AuthGuard — the IdP owns authentication pages.
// The app owns login initiation, callback handling, success, error, and logout UX.
function AuthLayout() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
      }}
    >
      <Outlet />
    </div>
  );
}
